import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { useNavigateWithScrollMemory } from '../../hooks/useNavigateWithScrollMemory';
import CommentCount from '../common/CommentCount';
import BookmarkCount from '../common/BookmarkCount';
import theme from '../../theme';
import CardTitle from '../common/CardTitle';

const NoticeHeadlineCard = ({ notice }) => {
  const navigateWithScrollMemory = useNavigateWithScrollMemory();
  const noticeUrl = `/notice/${notice.slug || notice.id}`;

  const handleLinkToNotice = (e) => {
    if (!e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      navigateWithScrollMemory(noticeUrl);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: '12px', lg: '16px' },
      }}
    >
      {/* 제목 */}
      <CardTitle title={notice.title} to={noticeUrl} onClick={handleLinkToNotice} />

      {/* 날짜 | 댓글 북마크 */}
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography
          fontSize={{ xs: 12, md: 14 }}
          color={theme.palette.black[4]}
          sx={{ whiteSpace: 'nowrap' }}
        >
          {notice.createdAt}
        </Typography>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ height: 8, alignSelf: 'center', backgroundColor: theme.palette.grey.line }}
        />
        <Stack direction="row" spacing={{ xs: 1, md: 1.5 }} alignItems="center">
          <CommentCount commentCount={notice.commentCount} />
          <BookmarkCount bookmarkCount={notice.bookmarkCount} />
        </Stack>
      </Stack>
    </Box>
  );
};

export default NoticeHeadlineCard;
